var map = {
	"./_faq": "6cN8",
	"./de_faq": "zUTK",
	"./es_faq": "UW1x",
	"./fr_faq": "Jz0W",
	"./keto_faq": "BuQG",
	"./pt_faq": "HVZJ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "m5bJ";